import { MockDataRow, TableColumn } from "./table.interface";

export const TABLE_MOCK_DATA: MockDataRow[] = [
   
  {
    nombre: 'Producto Delta',
    estado: 'pendiente',
    tipoCarga: 'automatica',
    categoria: 'Electrónicos',
    precio: 399.99,
    fechaCreacion: '2024-02-05',
    descripcion: 'Descripción del producto Delta',
    toggleActive: false,
    metodo: {
      nombre: 'Criptomonedas',
      foto: 'https://ichef.bbci.co.uk/ace/ws/800/cpsprodpb/6B34/production/_94244472_9.jpg.webp'
    }
  }

];

export const MOCK_FILTER_OPTIONS = {
  estado: [
    { label: 'Activo', value: 'activo' },
    { label: 'Inactivo', value: 'inactivo' }
  ],
  tipoCarga: [
    { label: 'Manual', value: 'manual' },
    { label: 'Automática', value: 'automatica' }
  ],
  categoria: [
    { label: 'Electrónicos', value: 'Electrónicos' },
    { label: 'Hogar', value: 'Hogar' },
    { label: 'Deportes', value: 'Deportes' },
    { label: 'Libros', value: 'Libros' },
    { label: 'Ropa', value: 'Ropa' }
  ]
};

export const MOCK_FILTER_LABELS = {
  estado: 'Estado',
  tipoCarga: 'Tipo de carga',
  categoria: 'Categoría'
};

export const MOCK_COLUMNS: TableColumn[] = [
  { key: 'nombre', label: 'Nombre', sortable: true, type: 'default' },
  { key: 'estado', label: 'Estado', sortable: true, type: 'chip' },
  { key: 'tipoCarga', label: 'Tipo de Carga', sortable: true, type: 'default' },
  { key: 'categoria', label: 'Categoría', sortable: true, type: 'default' },
  { key: 'precio', label: 'Precio', sortable: true, type: 'default' },
  { key: 'fechaCreacion', label: 'Fecha Creación', sortable: true, type: 'default' },
  { key: 'metodo', label: 'Método de pago', type: 'card' },
  { key: 'toggleActive', label: 'Activo', type: 'check' }
];